import { useState } from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export function useSort(rows, getters, initial = null) {
  const [sort, setSort] = useState(initial);
  const toggle = (key) => setSort((s) => (s?.key === key ? (s.dir === "asc" ? { key, dir: "desc" } : null) : { key, dir: "asc" }));
  if (!sort || !getters[sort.key]) return { rows, sort, toggle };
  const g = getters[sort.key];
  const sorted = [...rows].sort((a, b) => {
    const x = g(a), y = g(b);
    const r = typeof x === "number" && typeof y === "number" ? x - y : String(x ?? "").localeCompare(String(y ?? ""), undefined, { numeric: true });
    return sort.dir === "asc" ? r : -r;
  });
  return { rows: sorted, sort, toggle };
}

export function SortTh({ label, k, sort, toggle, testid }) {
  if (!k) return <th className="p-3 font-normal">{label}</th>;
  const Icon = sort?.key !== k ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className="p-3 font-normal">
      <button onClick={() => toggle(k)} className={`inline-flex items-center gap-1 hover:text-[#1A1412] ${sort?.key === k ? "text-[#1A1412]" : ""}`} data-testid={`${testid}-sort-${k}`}>
        {label}<Icon size={11} />
      </button>
    </th>
  );
}
